module.exports = __webpack_public_path__ + "img/med-avatar2.f07bb5d7.png";